<template>
  <div
    :class="{ 'faded-content': this.$store.state.headerStatus == 'menu' || this.$store.state.headerStatus == 'title' || this.$store.state.headerStatus == 'openSubmenu' }"
  >
    <scroll-wrapper-desktop v-if="!$store.state.userAgent.device.isMobile">
      <component v-bind:is="$route.meta.page"></component>
    </scroll-wrapper-desktop>
    <scroll-wrapper-mobile v-else>
      <component v-bind:is="$route.meta.page"></component>
    </scroll-wrapper-mobile>
    <side-menu></side-menu>
    <content-switches></content-switches>

    <wave></wave>
  </div>
</template>

<script>
import Psoriasis from '@/components/Content/Psoriasis';
import Tremfya from '@/components/Content/Tremfya';
import Wave from '@/components/Wave/Wave';
import SideMenu from '@/components/blocks/SideMenu/SideMenu';
import ContentSwitches from '@/components/blocks/ContentSwitches/ContentSwitches';
import ScrollWrapperDesktop from '@/components/ScrollWrapper/ScrollWrapperDesktop';
import ScrollWrapperMobile from '@/components/ScrollWrapper/ScrollWrapperMobile';

export default {
  data() {
    return {};
  },
  components: {
    Psoriasis,
    Tremfya,
    SideMenu,
    ContentSwitches,
    ScrollWrapperDesktop,
    ScrollWrapperMobile,
    Wave
  }
};
</script>

<style>
</style>
